module.exports = __webpack_public_path__ + "media/msg.987edcbe.mp3";